import { useApp } from '../../state/AppContext';
import Icon from '../../lib/Icon';
import { kv } from '../../lib/format';
import { cardPad } from '../../lib/ui';

export default function PoDetail() {
  const { state, go, set, openEsign, L } = useApp();
  const po = state.openedPo;

  // A pending PO opened from PO Management → approval + e-signature screen.
  if (po?.pending) {
    const details: [string, string, string][] = [
      [L('PO Number', 'เลขที่ PO'), po.id, 'var(--font-mono)'],
      [L('Supplier', 'ซัพพลายเออร์'), po.sup, 'var(--font-sans)'],
      [L('Status', 'สถานะ'), L('Pending Approval', 'รออนุมัติ'), 'var(--font-sans)'],
      [L('Value', 'มูลค่า'), po.value, 'var(--font-mono)'],
      [L('DOA Level', 'ระดับ DOA'), po.doa, 'var(--font-sans)'],
    ];
    const lifecycle = [
      { label: L('PO Issued', 'ออก PO แล้ว'), icon: 'check', color: 'var(--color-success)' },
      { label: L('Awaiting approval & e-signature', 'กำลังรอการอนุมัติและลายเซ็นอิเล็กทรอนิกส์'), icon: 'clock', color: 'var(--color-warning)' },
      { label: L('Goods / Service Received', 'รับสินค้า / บริการแล้ว'), icon: 'clock', color: 'var(--color-fg-3)' },
      { label: L('Goods / Service Received', 'รับสินค้า / บริการแล้ว'), icon: 'clock', color: 'var(--color-fg-3)' },
      { label: L('3-Way Match', 'การจับคู่ 3 ทาง'), icon: 'clock', color: 'var(--color-fg-3)' },
      { label: L('Payment', 'การชำระเงิน'), icon: 'clock', color: 'var(--color-fg-3)' },
    ];
    return (
      <>
        <button onClick={() => go('po')} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 600, color: 'var(--color-fg-2)', marginBottom: 16 }}><Icon name="arrow-left" />{L('Back to PO Management', 'กลับไปหน้าจัดการ PO')}</button>

        {/* Approval action bar */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap', justifyContent: 'space-between', background: 'var(--color-primary-light)', border: '1px solid var(--color-primary-border)', borderRadius: 'var(--radius-md)', padding: '18px 20px', marginBottom: 16 }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
            <Icon name="pen-tool" style={{ color: 'var(--color-primary)', fontSize: 22, flex: 'none', marginTop: 2 }} />
            <div>
              <div style={{ fontWeight: 700, marginBottom: 3 }}>{L('Approval Required', 'ต้องการการอนุมัติ')}</div>
              <div style={{ fontSize: 13, color: 'var(--color-fg-2)' }}>{po.id}{L(' is awaiting your approval and e-signature · DOA level: ', ' กำลังรอการอนุมัติและลายเซ็นอิเล็กทรอนิกส์ของคุณ · ระดับ DOA: ')}<b>{po.doa}</b>.</div>
            </div>
          </div>
          <button onClick={() => openEsign(po.id)} className="hv-primary" style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '11px 22px', background: 'var(--color-primary)', color: '#fff', borderRadius: 'var(--radius-md)', fontWeight: 600, fontSize: 14, flex: 'none' }}><Icon name="pen-tool" />{L('Approve & Sign', 'อนุมัติและลงนาม')}</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, alignItems: 'start' }}>
          <div style={cardPad(20)}>
            <div style={{ fontWeight: 700, marginBottom: 6 }}>{L('PO Details', 'รายละเอียด PO')}</div>
            <div style={{ fontSize: 13, color: 'var(--color-fg-2)', marginBottom: 14 }}>{po.desc}</div>
            {details.map(([k, v, f]) => (
              <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--color-border)' }}>
                <span style={{ fontSize: 12, color: 'var(--color-fg-3)' }}>{k}</span>
                <span style={{ fontSize: 13, fontWeight: 600, fontFamily: f }}>{v}</span>
              </div>
            ))}
          </div>
          <div style={cardPad(20)}>
            <div style={{ fontWeight: 700, marginBottom: 14 }}>{L('Lifecycle', 'วงจร')}</div>
            {lifecycle.map((s) => (
              <div key={s.label} style={{ display: 'flex', alignItems: 'center', gap: 11, padding: '7px 0' }}>
                <Icon name={s.icon} style={{ color: s.color, fontSize: 18 }} />
                <span style={{ fontSize: 13, fontWeight: 500, color: s.color }}>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </>
    );
  }

  const poKpis = [
    { label: L('PO Value', 'มูลค่า PO'), value: '$4,620,000', color: 'var(--color-fg-1)' },
    { label: L('Invoiced', 'ออกใบแจ้งหนี้แล้ว'), value: '$4,975,500', color: 'var(--color-error)' },
    { label: L('Goods Receipts', 'ใบรับสินค้า'), value: '1', color: 'var(--color-fg-1)' },
    { label: L('3-Way Match', 'การจับคู่ 3 ทาง'), value: L('Variance', 'ส่วนต่าง'), color: 'var(--color-error)' },
  ];
  const poDetails = [
    kv(L('Supplier', 'ซัพพลายเออร์'), 'Apex Insurance Co.', 'var(--font-sans)'),
    kv(L('Status', 'สถานะ'), L('Active', 'ใช้งาน'), 'var(--font-sans)'),
    kv(L('Issued', 'วันที่ออก'), '2026-06-22', 'var(--font-mono)'),
    kv(L('Delivery Due', 'กำหนดส่งมอบ'), '2026-07-01', 'var(--font-mono)'),
    kv(L('DOA Level', 'ระดับ DOA'), L('Director', 'ผู้อำนวยการ'), 'var(--font-sans)'),
    kv(L('e-Signature', 'ลายเซ็นอิเล็กทรอนิกส์'), 'ESC-7F3A9C21', 'var(--font-mono)'),
    kv(L('Source RFQ', 'RFQ ต้นทาง'), 'RFQ-2026-001', 'var(--font-mono)'),
    kv(L('Requested by', 'ผู้ขอ'), 'Maria B.', 'var(--font-sans)'),
  ];
  const poLines = [
    { item: 'INS-C1', desc: 'Class 1 Comprehensive — 8 fleet vehicles', unit: 'policy', ordered: '1' },
  ];
  const poInvoices = [
    { no: 'INV-2026-0063', date: '2026-07-02', due: '2026-08-01', amount: '$4,650,000', total: '$4,975,500', variance: '+$30,000', status: L('Variance', 'ส่วนต่าง') },
  ];
  const poLifecycle = [
    { label: L('PO Issued', 'ออก PO แล้ว'), done: true },
    { label: L('Approved & e-Signed (Director)', 'อนุมัติและลงนามอิเล็กทรอนิกส์แล้ว (ผู้อำนวยการ)'), done: true },
    { label: L('Goods / Service Received', 'รับสินค้า / บริการแล้ว'), done: true },
    { label: L('Invoice Received', 'รับใบแจ้งหนี้แล้ว'), done: true },
    { label: L('3-Way Match', 'การจับคู่ 3 ทาง'), done: false, warn: true },
    { label: L('Payment', 'การชำระเงิน'), done: false },
  ].map((s) => ({ ...s, icon: s.done ? 'check' : s.warn ? 'alert-triangle' : 'clock', color: s.done ? 'var(--color-success)' : s.warn ? 'var(--color-error)' : 'var(--color-fg-3)' }));

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 16, marginBottom: 16 }}>
        {poKpis.map((k) => (
          <div key={k.label} style={cardPad('16px 18px')}>
            <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: 'var(--color-fg-3)', marginBottom: 6 }}>{k.label}</div>
            <div style={{ fontSize: 22, fontWeight: 700, fontFamily: 'var(--font-mono)', color: k.color }}>{k.value}</div>
          </div>
        ))}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, alignItems: 'start' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div style={cardPad(20)}>
            <div style={{ fontWeight: 700, marginBottom: 14 }}>{L('PO Details', 'รายละเอียด PO')}</div>
            {poDetails.map((d) => (
              <div key={d.k} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--color-border)' }}>
                <span style={{ fontSize: 12, color: 'var(--color-fg-3)' }}>{d.k}</span>
                <span style={{ fontSize: 13, fontWeight: 600, fontFamily: d.font }}>{d.v}</span>
              </div>
            ))}
          </div>
          <div style={cardPad(20)}>
            <div style={{ fontWeight: 700, marginBottom: 12 }}>{L('Line Items', 'รายการสินค้า')}</div>
            {poLines.map((l) => (
              <div key={l.item} style={{ display: 'flex', gap: 12, padding: '10px 0', borderBottom: '1px solid var(--color-border)' }}>
                <span style={{ fontFamily: 'var(--font-mono)', fontWeight: 600, fontSize: 12 }}>{l.item}</span>
                <div style={{ flex: 1, fontSize: 13 }}>{l.desc}</div>
                <span style={{ fontSize: 12, color: 'var(--color-fg-3)' }}>{l.ordered} {l.unit}</span>
              </div>
            ))}
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div style={{ background: 'var(--color-warning-bg)', border: '1px solid var(--color-warning)', borderRadius: 'var(--radius-md)', padding: '16px 18px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 700, marginBottom: 6 }}><Icon name="alert-triangle" style={{ color: 'var(--color-warning)' }} />{L('3-Way Match — Variance', 'การจับคู่ 3 ทาง — ส่วนต่าง')}</div>
            <div style={{ fontSize: 13, color: 'var(--color-fg-2)', marginBottom: 12 }}>{L('Invoiced amount exceeds the PO value by $30,000. Payment is on hold pending resolution.', 'ยอดที่ออกใบแจ้งหนี้เกินมูลค่า PO อยู่ $30,000 การชำระเงินถูกระงับจนกว่าจะแก้ไข')}</div>
            <button onClick={() => go('match')} className="hv-ink" style={{ fontSize: 13, fontWeight: 600, padding: '8px 14px', border: '1px solid var(--color-border-strong)', borderRadius: 'var(--radius-sm)', background: 'var(--color-white)' }}>{L('Open 3-Way Match →', 'เปิดการจับคู่ 3 ทาง →')}</button>
          </div>
          <div style={cardPad(20)}>
            <div style={{ fontWeight: 700, marginBottom: 12 }}>{L('Invoices', 'ใบแจ้งหนี้')}</div>
            {poInvoices.map((iv) => (
              <div key={iv.no} style={{ border: '1px solid var(--color-error)', borderRadius: 'var(--radius-sm)', padding: 12, background: 'var(--color-error-bg)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                  <span style={{ fontFamily: 'var(--font-mono)', fontWeight: 700, fontSize: 13 }}>{iv.no}</span>
                  <span style={{ fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 999, background: 'var(--color-error)', color: '#fff' }}>{iv.status}</span>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, fontSize: 12, color: 'var(--color-fg-2)' }}>
                  <div>{L('Amount', 'จำนวนเงิน')}: <b style={{ fontFamily: 'var(--font-mono)' }}>{iv.amount}</b></div>
                  <div>{L('Total incl. VAT', 'ยอดรวมภาษีมูลค่าเพิ่ม')}: <b style={{ fontFamily: 'var(--font-mono)' }}>{iv.total}</b></div>
                  <div>{L('Due', 'กำหนดชำระ')}: <span style={{ fontFamily: 'var(--font-mono)' }}>{iv.due}</span></div>
                  <div style={{ color: 'var(--color-error)' }}>{L('Variance', 'ส่วนต่าง')}: <b style={{ fontFamily: 'var(--font-mono)' }}>{iv.variance}</b></div>
                </div>
                <button onClick={() => set({ invoiceDocOpen: true })} style={{ marginTop: 8, fontSize: 12, fontWeight: 600, color: 'var(--color-blue)', display: 'flex', alignItems: 'center', gap: 5 }}><Icon name="eye" />{L('View invoice', 'ดูใบแจ้งหนี้')}</button>
              </div>
            ))}
          </div>
          <div style={cardPad(20)}>
            <div style={{ fontWeight: 700, marginBottom: 14 }}>{L('Lifecycle', 'วงจร')}</div>
            {poLifecycle.map((s) => (
              <div key={s.label} style={{ display: 'flex', alignItems: 'center', gap: 11, padding: '7px 0' }}>
                <Icon name={s.icon} style={{ color: s.color, fontSize: 18 }} />
                <span style={{ fontSize: 13, fontWeight: 500, color: s.color }}>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
